import { render, staticRenderFns } from "./CorporateEmployeesForm.vue?vue&type=template&id=2fe3522e"
import script from "./CorporateEmployeesForm.vue?vue&type=script&lang=js"
export * from "./CorporateEmployeesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports